var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilderStep3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke-width: 22.3px;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke: #161617;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #f7cc11;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #161617;\r\n        stroke-width: 6px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "160.9 152.9 144.6 179.1 141.9 193.7 199.8 205.5 235.2 191.8 229.7 176.8 203.8 153.9 187 146.7 160.9 152.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "279.1 153.2 262.8 179.3 260.1 193.9 318 205.7 353.4 192 341.6 176.9 329.2 157.7 303.3 142.5 279.1 153.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 133.4,
    y: 281.3,
    width: 24.2,
    height: 61.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 223.3,
    y: 281.3,
    width: 24.2,
    height: 61.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 345.5,
    y: 281.3,
    width: 24.2,
    height: 61.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213,143.2c-6.4-3.3-13.5-5.3-20.7-5.7-7.2-.4-14.5.8-21.2,3.7-13.2,5.8-24,18.4-26.8,39.3-.3,2,1.2,3.8,3.3,4,2,.3,3.9-1.2,4.2-3.1,2.4-17.9,11.2-28.6,22.2-33.5,0,0,14.9-3.4,17.7-3.3,2.3.1,4.5.5,6.6.9l9.5,3.2c.5.2,1,.5,1.5.7,11.4,5.9,20,16.9,20.7,31.6,0,1.9,1.8,3.5,3.9,3.4,2,0,3.7-1.7,3.6-3.7-.7-17.4-11.1-30.6-24.6-37.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.2,197c9.6,6,25.7,8.8,42.2,8.9,16.3,0,33.1-2.6,44.1-7.9,5.2-2.5,9.2-5.6,11.5-9.2l-6.4-3.7c-1.5,2.4-4.5,4.6-8.4,6.4-10,4.7-25.6,7.2-40.8,7.2-15.2,0-29.8-2.5-38.2-7.7-2.4-1.5-5.1-5-5.4-5.5l-6.8,3c1.6,3.3,4.4,6.2,8.2,8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M330,143.2c-6.4-3.3-13.5-5.3-20.7-5.7-7.2-.4-14.5.8-21.2,3.7-13.2,5.8-24,18.4-26.8,39.3-.3,2,1.2,3.8,3.3,4,2,.3,3.9-1.2,4.2-3.1,2.4-17.9,11.2-28.6,22.2-33.5,0,0,9.4-2.9,9.4-2.9,2.7-.5,5.5-.5,8.3-.4,2.3.1,4.5.5,6.6.9l9.5,3.2c.5.2,1,.5,1.5.7,11.4,5.9,20,16.9,20.7,31.6,0,1.9,1.8,3.5,3.9,3.4,2,0,3.7-1.7,3.6-3.7-.7-17.4-11.1-30.6-24.6-37.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 186.3,
    y: 303.3,
    width: 9.1,
    height: 8.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 303.3,
    y: 303.3,
    width: 9.1,
    height: 8.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M399.9,300c-3.7-5.3-8.9-9.9-15.5-13.5-.2-.1-.3-.2-.5-.3l-50.9-20.8v-14.5c1-1,2-2.1,3-3.2,6.4-7.5,10.4-17.5,11.7-29.6l2.4-3c.6-.7.9-1.6.8-2.5v-5.8c0,0-7.4,0-7.4,0v4.8c0,0-2.3,2.8-2.3,2.8-.5.5-.7,1.2-.8,1.9-1.1,11.1-4.5,20.2-10.2,26.8-5.3,6.2-12.7,10.2-22.1,11.7-8.7-1.3-16.4-4.1-22.1-9.6-5.9-5.7-9.7-14.7-10.8-28.8,0-.8-.4-1.6-1-2.2l-2.5-2.6v-4.5h-7.5v5.9c0,1,.5,2,1.2,2.7l2.5,2.5c1.4,15.2,6,25.2,12.8,32,.5.5.9.9,1.4,1.4v14.4l-15.4,6.3c3.4,3,6.4,5.7,9.1,8.1v-3.9l9.6-3.9,20.2,22.1h5.7l20.2-22.1,9.6,3.9v63.4h7.6v-60.2l14,5.8v54.5h7.6v-51.4l10.4,4.2c5.6,3.1,9.9,6.8,12.9,11.2,3,4.4,4.7,9.4,5.1,15.2v20.9h7.6v-21.1c-.5-7.1-2.7-13.3-6.4-18.8ZM325.5,268l-17.1,18.6-18.7-20.4v-9.6h0c5.4,2.7,11.5,4.3,18,5.3.4,0,.9,0,1.2,0,6.2-.9,11.8-2.8,16.6-5.6v11.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.2,197c9.6,6,25.7,8.8,42.2,8.9,16.3,0,33.1-2.6,44.1-7.9,5.2-2.5,9.2-5.6,11.5-9.2l-6.4-3.7c-1.5,2.4-4.5,4.6-8.4,6.4-10,4.7-25.6,7.2-40.8,7.2-15.2,0-29.8-2.5-38.2-7.7-2.4-1.5-5.1-5-5.4-5.5l-6.8,3c1.6,3.3,4.4,6.2,8.2,8.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 303.3,
    y: 325.7,
    width: 9.1,
    height: 8.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.4,286.5c-.2-.1-.3-.2-.5-.3l-50.9-20.8v-14.5c1-1,2-2.1,3-3.2,6.4-7.5,10.4-17.5,11.7-29.6l2.4-3c.6-.7.9-1.6.8-2.5v-5.8c0,0-7.4,0-7.4,0v4.8c0,0-2.3,2.8-2.3,2.8-.5.5-.7,1.2-.8,1.9-1.1,11.1-4.5,20.2-10.2,26.8-5.3,6.2-12.7,10.2-22.1,11.7-8.7-1.3-16.4-4.1-22.1-9.6-5.9-5.7-9.7-14.7-10.8-28.8,0-.8-.4-1.6-1-2.2l-2.5-2.6v-4.5h-7.6v5.9c0,1,.5,2,1.2,2.7l2.5,2.5c1.4,15.2,6,25.2,12.8,32,.5.5.9.9,1.4,1.4v14.4l-49.2,20.1c-.2,0-.4.2-.5.3-6.6,3.6-11.9,8.1-15.5,13.5-3.8,5.5-5.9,11.7-6.4,18.8v21.1h7.6v-20.8c.5-5.8,2.1-10.8,5.1-15.2,3-4.4,7.3-8.1,12.9-11.2l10.4-4.2v51.4h7.6v-54.4l14.3-5.9v60.3h7.6v-63.4l9.6-3.9,20.2,22.1h5.7l20.2-22.1,9.6,3.9v63.4h7.6v-60.2l14,5.8v54.5h7.6v-51.4l10.4,4.2c5.6,3.1,9.9,6.8,12.9,11.2s4.7,9.4,5.1,15.2v20.9h7.6v-21.1c-.5-7.1-2.7-13.3-6.4-18.8-3.7-5.3-8.9-9.9-15.5-13.5ZM208.5,268l-17.1,18.6-18.7-20.4v-9.6h0c5.4,2.7,11.5,4.3,18,5.3.4,0,.9,0,1.2,0,6.2-.9,11.8-2.8,16.6-5.6v11.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 186.3,
    y: 325.7,
    width: 9.1,
    height: 8.8
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 250.5,
    cy: 250,
    r: 214.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilderStep3);
export default __webpack_public_path__ + "static/media/Builder-Step3.c65ff34b6947d32d7c017e4d864c39f9.svg";
export { ForwardRef as ReactComponent };